export const SESSIONS_SHEET_ID = "1TvZVMFOvmNuBUZKB53aFPM7Rz0BEY2ZSxJyJPIJwBNQ";
export const SESSIONS_PAST_GID = "1596087451";
export const SESSIONS_UPCOMING_GID = "0";

export const SESSIONS_YOUTUBE_URL =
  "https://www.youtube.com/@PyCrayForge?sub_confirmation=1";

export const SESSIONS_YOUTUBE_CHANNEL = "https://www.youtube.com/@PyCrayForge";

export const PYCRAY_FORGE_CHANNEL_ID = "UC4l6_AhUhkQVftwtWkmV2Cg";

export const PYCRAY_FORGE_VIDEO_FALLBACK = [
  { title: "How to Read and Write Technical Documentation Like a Pro", id: "J8Qzj_WbnFs" },
  { title: "How Software Actually Gets Released — From Code to Customer", id: "4mcdCBLduWs" },
  { title: "What Is Product Thinking — and Why Every Tech Role Needs It", id: "ysBM5kiTOEQ" },
  { title: "How to Use AI Tools to Get Ahead in Your Tech Career", id: "JEYMlEF88wA" },
  { title: "How to Crack a Tech Interview With Zero Work Experience", id: "UCE6O9fZPrQ" },
  { title: "Build A Portfolio That Gets You Hired", id: "A5sCse7dmAE" },
  { title: "Which Tech Role Is Actually For You?", id: "wQ4PIrqXHUk" },
  { title: "Your First 30 Days at a Tech Job", id: "7h6lqkmYpxo" },
];

export function sessionsCsvUrl(gid) {
  return `https://docs.google.com/spreadsheets/d/${SESSIONS_SHEET_ID}/gviz/tq?tqx=out:csv&gid=${gid}&t=${Date.now()}`;
}
